<template>
  <div class="f-h-below-title meeting-templates-list">
    <div class="meeting-templates-list__search v-centerer">
      <Icon>{{ searchMedium }}</Icon>
      <input v-model="search" :placeholder="$t('message.FILTER_MEETINGS')">
    </div>
    <div class="meeting-templates-list__content">
      <div
        v-for="meeting in filteredMeetings"
        :key="meeting.id"
        class="small-card-item v-centerer mt10em"
        :class="{ selected: selectedMeetings.includes(meeting.id) }"
        @click="onMeetingClick(meeting)"
      >
        <span class="name">{{ meeting.name }}</span>
        <span class="info ml3em">{{ stepsNbString(meeting) }}</span>
      </div>
    </div>
    <button class="action-btn meeting-templates-list__ok" @click="$emit('ok', selectedMeetings)">
      {{ $t('message.OK') }}
    </button>
  </div>
</template>

<script>
/**
 * Fetch and display a filterable list of template meetings.
 *
 * @vue-event {Array} ok - Emit an array of selected meeting ids
 */

import toastr from 'toastr';
import { uniq } from 'lodash';
// Components
import Icon from '@/components/icon.vue';
// Utils
import { searchMedium } from '@/assets/icons/';

export default {

  name: 'MeetingTemplatesList',

  components: {
    Icon,
  },

  data() {
    return {
      searchMedium,
      search: '',
      meetings: [],
      selectedMeetings: [],
    };
  },

  computed: {
    /** Array: Array of meetings matching the search terms */
    filteredMeetings() {
      const effectiveSearch = this.search.toUpperCase().split(/[\s,-./']/);
      return this.meetings.filter(m => !effectiveSearch.some(term => !m.name.toUpperCase().includes(term)));
    },
  },

  created() {
    this.refresh();
  },

  methods: {
    refresh() {
      this.$http.post('/server/meetings/plannings/get.php', { templates: true }).then((response) => {
        if (response && response.data instanceof Array) {
          this.meetings = response.data;
        } else {
          toastr.error(this.$t('message.CONNECTION_ERROR'));
        }
      });
    },
    /** Handle click on a meeting item */
    onMeetingClick(meeting) {
      if (this.selectedMeetings.includes(meeting.id)) {
        this.selectedMeetings = this.selectedMeetings.filter(meetingId => meetingId !== meeting.id);
      } else {
        this.selectedMeetings = uniq([...this.selectedMeetings, meeting.id]);
      }
    },
    /** String: Details added next to the name of the meeting */
    stepsNbString(meeting) {
      const nbSteps = this.$tc('message.MEETING_N_STEPS', meeting.stepsData.length, { n: meeting.stepsData.length });
      return this.$t('message.CONTENT_BETWEEN_PARENTHESES', { content: nbSteps });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";
.meeting-templates-list {
  height: 100%;
  padding: 1em;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;

  &__search {
    flex: 0 0 auto;
    background: #fff;
    margin: 0.5em;
    border: 1px solid #888888;

    .icon {
      margin: 0 0.5em;
      width: 1.4em;
      height: 1.4em;
    }

    input {
      margin: 0px;
      padding: 0.5em;
      border: none;
      width: 100%;
    }
  }

  &__content {
    flex: 1;
    overflow: auto;
    padding: .5em;
  }

  &__ok {
    flex: 0 0 auto;
    align-self: center;
  }

  .small-card-item {
    margin-bottom: 0px;
    width: 100%;
    box-sizing: border-box;

    &.selected {
      background: $color-hoverbtn-blue;
    }
  }
}
</style>
